<div class="dashboard-retrieval-container">
  <div class="header bold">{{headerTitle}}</div>
  <div class="dashboard-container">
    <div class="dashboard-left">
      <div class="item" *ngFor="let item of headerStatistics; let i = index, trackBy: trackByIndex">
        <p class="header-statistics">{{item.key}}</p>
        <span (click)="getStatisticsFilter(item.key)" class="users-land-stats-item bold" [ngClass]="(item.key===selectedStat ? 'activeStat' : 'clearStat')">{{item.value}}</span>
      </div>
    </div>
    <div style="clear:both"></div>

  </div>
  <div class="results">

    <app-server-grid [configuration]="serverGridConfiguration"
                     [(request)]="serverRequest"
                     [filterTemplate]="filterTemplate"
                     [actionTemplate]="actionTemplate"
                     [actions]="actions"
                     [(selection)]="documentApprovalGridSelection"
                     [refresh]="refreshGrid"
                     (dataLoaded)="onApprovalGridDataLoaded($event)">

      <ng-template #docIdColumn let-rowData>
        <a [routerLink]="" (click)="showDocumentModal(rowData)">{{ rowData.documentQueueId }}</a>
      </ng-template>

      <ng-template #chaseIdColumn let-rowData>
        <app-chase-grid-chase-id [isOverreadFeedbackEmpty]="true" [isCurrentUserAbstractorForOverreadFeedback]="false"
          [data]="rowData" chaseIdUrl="/members/chase/:chaseId"></app-chase-grid-chase-id>
      </ng-template>

      <ng-template #actionTemplate
                   let-rowData let-localActionPopover="actionPopover">
        <div class="action-template-container">
          <app-button *ngFor="let action of actions; trackBy: trackByIndex"
                      [text]="action.name"
                      (onClick)="action.action(rowData); localActionPopover.hide();"
                      [disabled]="disableAction(action.name,rowData)"></app-button>
        </div>
      </ng-template>

      <!--////Filter-->
      <ng-template #filterTemplate let-form>
        <form [formGroup]="form">
          <app-tab-menu orientation="left" (activeIndexChange)="onActiveIndexChange($event)">
            <app-tab-panel header="Document Id">
              <div class="p-col-12 p-md-12 p-lg-12">
                <form-factory [formGroup]="form" [model]="documentQueueId"></form-factory>
              </div>
            </app-tab-panel>
            <app-tab-panel class="checkbox-group__halves" header="Retrieval Method">
              <div class="p-col-12 p-md-12 p-lg-12">
                <form-factory [formGroup]="form" [model]="retreivalType"></form-factory>
              </div>
            </app-tab-panel>

            <app-tab-panel header="Original Chase Id">
              <div class="p-col-12 p-md-12 p-lg-12">
                <form-factory [formGroup]="form" [model]="chaseId"></form-factory>
              </div>
            </app-tab-panel>

            <app-tab-panel header="Chase Key">
              <div class="p-col-12 p-md-12 p-lg-12">
                <form-factory [formGroup]="form" [model]="chaseSourceAliasId"></form-factory>
              </div>
            </app-tab-panel>

            <app-tab-panel class="checkbox-group__fourths" header="Measures">
              <div class="p-col-12 p-md-12 p-lg-12">
                <form-factory [formGroup]="form" [model]="measureCode"></form-factory>
              </div>
            </app-tab-panel>

            <app-tab-panel class="checkbox-group__halves" header="Original Chase Status">
              <div class="p-col-12 p-md-12 p-lg-12">
                <form-factory [formGroup]="form" [model]="chaseStatus"></form-factory>
              </div>
            </app-tab-panel>

            <app-tab-panel header="Sample Compliance">
              <div class="p-col-12 p-md-12 p-lg-12">
                <form-factory [formGroup]="form" [model]="sampleComplianceCode"></form-factory>
              </div>
            </app-tab-panel>

            <app-tab-panel class="checkbox-group__halves" header="Projects">
              <div class="p-col-12 p-md-12 p-lg-12">
                <form-factory [formGroup]="form" [model]="projectName"></form-factory>
              </div>
            </app-tab-panel>

          </app-tab-menu>
        </form>
      </ng-template>
      <!--/End/////-->
    </app-server-grid>
    <app-modal [(visible)]="isViewDetailVisible" header="VIEW DETAILS">
      <div class="documentPageViewerContainer">
        <app-document-page-viewer #pageviewer
                                  [sourceDocumentTypeId]="4"
                                  [maxPages]="3">
        </app-document-page-viewer>
      </div>

    </app-modal>
    <app-confirmation-modal [(visible)]="showConfirmationForPursuitCreationOnApprove"
                            header="ATTENTION"
                            (onYes)="approveMultipleDocumentAndCreatePursuit()">
      {{approvePopUpConfirmationText}}
    </app-confirmation-modal>   
    <app-modal [(visible)]="showPostApprovalMessage" header="SUCCESSFUL" rejectText="CLOSE">
      <div *ngIf="isChaseActivated; else pagesAdded">
        Chase Successfully Activated!
      </div>
      <ng-template #pagesAdded>
        Pages successfully added to child chase <a routerLink="{{url}}" href="#">{{ approvalPursuitChaseId }}</a>
      </ng-template>
    </app-modal>

    <app-modal [(visible)]="isDocumentModalVisble"
               (visibleChange)="visibleChange($event)"
               rejectText="CLOSE"
               class="view-document-modal">
      <div *ngIf="selectedDocId">
        <app-document-page-viewer [chaseId]="selectedDocId"
                                  [isDocApproval]="true"
                                  [disableMaximize]="true">
        </app-document-page-viewer>
      </div>
      <footer>
        <app-button classes="success" text="APPROVE" (onClick)="closeModalAndApproveOrDeny('approve')"></app-button>
        <app-button classes="danger" text="DENY" (onClick)="closeModalAndApproveOrDeny('deny')"></app-button>
      </footer>
    </app-modal>

    <app-manage-tag-modal [(visible)]="isManageTagModalVisible"
                          (onHide)="closeModal()"
                          [(selectedData)]="selectedDocuments"
                          [entityName]="entityName"
                          [totalEntityCount]="totalEntityCount"
                          [tagType]="tagType">
    </app-manage-tag-modal>
  </div>
</div>

